export default {"src":"/_next/static/media/infravelo.0769cbe8.svg","height":76,"width":210,"blurWidth":0,"blurHeight":0};